export const SEARCH_COMMANDS = "search_commands";
export const APPLICATION_MENU = "__title__";

